import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { linkResolver } from "../../utilities/prismic-linkResolver";
import Anchor from "../elements/Anchor";
import regions from "../../../static/images/icons/regions.svg";
import "../../styles/components/slices/spitogatos.scss";

const Spitogatos = ({ slice }) => {
  if (!slice) return null;
  const { title1, my_text, image_logo } = slice.primary;

  const [region, setRegion] = useState("Επιλέξτε...");

  const urls = {
    Αττική:
      "https://www.spitogatos.gr/pwliseis-katoikies/pollaples_perioxes-100,101,102,103,104/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
    Θεσσαλονίκη:
      "https://www.spitogatos.gr/pwliseis-katoikies/pollaples_perioxes-108,109,110/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
    Ιόνιο:
      "https://www.spitogatos.gr/pwliseis-katoikies/pollaples_perioxes-124230,124274,162,171,172,181,3612/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
    Κυκλάδες:
      "https://www.spitogatos.gr/pwliseis-katoikies/kyklades/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
    Κρήτη:
      "https://www.spitogatos.gr/pwliseis-katoikies/pollaples_perioxes-165,179,188,197/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
    Δωδεκάνησα:
      "https://www.spitogatos.gr/pwliseis-katoikies/dodekanisa/timi_eos-250000/emvado_eos-150/etos_kataskevis_eos-2007",
  };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    if (urls[region]) {
      window.open(urls[region], "_blank");
    } else {
      alert("Παρακαλώ επιλέξτε μια έγκυρη περιοχή.");
    }
  };

  return (
    <Container fluid className="spitogatos">
      <Container className="max-container">
        <Row className="justify-content-center text-center">
          <Col md={7}>
            <h1 className="fw-light mb-5">{title1.text}</h1>
          </Col>
          <Col md={8}>
            <PrismicRichText field={my_text.richText} />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={9}>
            {/* desktop */}
            <Form
              className="spitogatos-form mt-5 d-none d-md-block"
              noValidate
              onSubmit={onSubmit}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  <img src={regions} alt="regions icon" />
                  <p className="mb-0 ms-2">Περιοχή:</p>
                </div>
                <Form.Group className="w-100 ms-5" controlId="formService">
                  <Form.Select
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    name="region"
                  >
                    <option value="Επιλέξτε..." disabled>
                      Eπιλογή Περιοχής
                    </option>
                    <option value="Αττική">Αττική</option>
                    <option value="Θεσσαλονίκη">Θεσσαλονίκη</option>
                    <option value="Ιόνιο">Ιόνιο</option>
                    <option value="Κυκλάδες">Κυκλάδες</option>
                    <option value="Κρήτη">Κρήτη</option>
                    <option value="Δωδεκάνησα">Δωδεκάνησα</option>
                  </Form.Select>
                </Form.Group>

                <div className="search-btn mona ms-4 col">
                  <button
                    type="submit"
                    className="btn"
                    // onClick={handleSubmit()}
                  >
                    Αναζήτηση
                  </button>
                </div>
              </div>
            </Form>

            {/* mobile */}
            <Form
              className="spitogatos-form mt-5 d-flex d-md-none"
              noValidate
              onSubmit={onSubmit}
            >
              <div className="d-flex flex-column justify-content-between align-items-center w-100">
                <div className="d-flex w-100">
                  <div className="d-flex">
                    <img
                      src={regions}
                      alt="regions icon"
                      style={{ width: "20px" }}
                    />
                  </div>
                  <Form.Group className="w-100 ms-2" controlId="formService">
                    <Form.Select
                      value={region}
                      onChange={(e) => setRegion(e.target.value)}
                      name="region"
                    >
                      <option value="Επιλέξτε..." disabled>
                        Eπιλογή Περιοχής
                      </option>
                      <option value="Αττική">Αττική</option>
                      <option value="Θεσσαλονίκη">Θεσσαλονίκη</option>
                      <option value="Ιόνιο">Ιόνιο</option>
                      <option value="Κυκλάδες">Κυκλάδες</option>
                      <option value="Κρήτη">Κρήτη</option>
                      <option value="Δωδεκάνησα">Δωδεκάνησα</option>
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="search-btn mona mt-3 w-100 text-center">
                  <button type="submit" className="btn">
                    Αναζήτηση
                  </button>
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Spitogatos;
